"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeAsset = void 0;
class NativeAsset {
    constructor() {
        this.nativeAsset = 'XRP';
        //
    }
    set(asset) {
        this.nativeAsset = asset.trim().toUpperCase();
    }
    get() {
        return this.nativeAsset;
    }
}
const nativeAsset = new NativeAsset();
exports.nativeAsset = nativeAsset;
//# sourceMappingURL=nativeasset.js.map